<template>
  <div class="application-group">
    <template v-for="(field, index) in configGroup.fields">

      <!-- 子标题 -->
      <application-subtitle
        v-if="field.type === 'TitleBox'"
        v-show="showField(field, applicationData)"
        :field="field"
        :key="index"
        @fieldValueChanged="fieldValueChanged"
      ></application-subtitle>
      <!-- 子标题 -->
      <application-tips
        v-else-if="field.type === 'TipsBox'"
        v-show="showField(field, applicationData)"
        :field="field"
        :key="index"
        @fieldValueChanged="fieldValueChanged"
      ></application-tips>

      <!-- 字段 -->
      <application-field
        v-else-if="field.type !== 'TitleBox' && field.type !== 'Popup'"
        v-show="showField(field, applicationData)"
        :field="field"
        :key="index"
        :field-index="index"
        :field-disabled="fieldDisbaled"
        :application-data="applicationData"
        :pcd-data="pcdData"
        :group-submitted="groupSubmitted"
        @fieldValueChanged="fieldValueChanged"
      ></application-field>

      <!-- 弹出组 -->
      <application-popup
        v-else-if="field.type === 'Popup'"
        v-show="showField(field, applicationData)"
        :field="field"
        :key="index"
        :field-index="index"
        :field-disabled="fieldDisbaled"
        :application-data="applicationData"
        :popup-data="applicationData[field.popupName]"
        :pcd-data="pcdData"
        :group-submitted="groupSubmitted"
        @fieldValueChanged="fieldValueChanged"
      ></application-popup>
    </template>
    <!-- 最后的确认 （最后一组里面才有确认 且 有些地方是不需要确认的 且 如果提交过就不需要再次确认）-->
    <el-checkbox
      class="ensure-checkbox"
      :value="inGroupFormEnsured"
      v-if="isLastGroup && needEnsure && !applicationData.ensured"
      @change="changeFormEnsured"
    >请确认以上资料正确无误，如因信息错误导致签证被拒绝，由申请方自行承担责任</el-checkbox>

    <div class="save-button-box" v-if="!fieldDisbaled">
      <el-button type="primary" class="save-application-group"
        @click="saveGroup()" :disabled="submitting">{{ btnDoSave ? '保存' : '提交申请表' }}</el-button>
    </div>
  </div>
</template>

<script>
import applicationFormService from '../../../services/application-form-service';

import applicationField from './application-field';
import applicationPopup from './application-popup';
import applicationSubtitle from './application-subtitle';
import utils from '../../../libs/utils';
import ApplicationTips from './application-tips';

import applicantConstants from '../../../constants/applicant-constants';
import materialConstants from '../../../constants/material-constants';

export default {
  name: 'application-group',
  components: {
    applicationField,
    applicationPopup,
    applicationSubtitle,
    ApplicationTips,
  },
  props: {

    // 申请表配置组
    configGroup: {
      type: Object,
      required: true,
      default: (() => ({})),
    },

    // 申请表状态
    applicationStatus: {
      type: Number,
      required: true,
      default: 0,
    },

    // 组序号
    groupIndex: {
      type: Number,
      required: true,
      default: 0,
    },

    // 是否是最后一个组
    isLastGroup: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 用户是否确认
    formEnsured: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 用户所填的申请表数据
    applicationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },

    // 申请表的配置数组
    applicationConfig: {
      type: Array,
      required: true,
    },

    // 省市区数据
    pcdData: {
      type: Object,
      required: true,
      default: (() => ({})),
    },

    // 是否是重新上传页面
    isReupload: {
      type: Boolean,
      default: false,
    },

    // 字段是否禁用
    fieldDisbaled: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 提交中
    submitting: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 是否需要确认
    needEnsure: {
      type: Boolean,
      default: true,
    },

    // 外部提交了表单
    formSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {

    // 按钮做保存操作的判断
    btnDoSave() {

      // 预审不通过页面 或者 在订单确认页面查看资料
      if (this.isReupload) {

        if (this.applicationStatus === materialConstants.APPLY_STATUS.waittingForVerified_2) {
          return true;
        } else if (this.applicationStatus === materialConstants.APPLY_STATUS.verifyNotPassed_3) {
          return false;
        }
        return true;
      }

      // 最后一组
      return !this.isLastGroup;
    },
  },
  data() {
    return {
      groupSubmitted: this.formSubmitted,
      inGroupFormEnsured: this.formEnsured,
    };
  },
  methods: {

    // 字段内容变化，直接向上冒泡
    fieldValueChanged(changeObject) {
      this.$emit('fieldValueChanged', changeObject);
    },

    // 用户确认变化
    changeFormEnsured(event) {
      this.inGroupFormEnsured = event.target.checked;
      this.$emit('changeFormEnsured', this.inGroupFormEnsured);
    },

    // 字段是否隐藏
    showField: applicationFormService.showField,

    // 申请表组保存
    saveGroup(onlyDoValidation) {

      // 不是最后一组，那就是保存
      this.groupSubmitted = true;
      const groupValid = applicationFormService.groupValid(this.configGroup, this.applicationData);
      if (groupValid) {

        // 这个字段是下面watch formSubmitted的变化的时候，要控制的, 就是说如果onlyDoValidation为true, 提交的时候就算没有错, 也不提交
        if (!onlyDoValidation) {
          // 如果申请表状态不是带上传，则需要校验所有的组都正常才能保存，要不然可能有些组会有数据未填写。
          if (this.applicationStatus === materialConstants.APPLY_STATUS.waittingForVerified_2) {
            if (
              !applicationFormService.formValid(
                this.applicationConfig,
                this.applicationData,
              )
            ) {
              // 有组校验不通过
              this.applicationConfig.forEach((group) => {
                // 把不通过的组设置一下
                const groupValid = applicationFormService.groupValid(group, this.applicationData);
                if (!groupValid) {
                  this.$emit('updateGroupStatus', group.name, applicantConstants.APPLICATION_GROUP_STATUS.invalid);
                }
              });
              utils.msg.error('内容输入不正确，请检查标红的部分');
              return;
            }
          }

          this.$emit('saveGroup', {
            name: this.configGroup.name,
            thenSubmitForm: !this.btnDoSave, // 根据究竟做什么来判断, 里面已经包含了是不是最后一组
          });
          this.$emit('updateGroupStatus', this.configGroup.name, applicantConstants.APPLICATION_GROUP_STATUS.valid);
        }
      } else {
        utils.msg.error('内容输入不正确，请检查标红的部分');
        this.$emit('updateGroupStatus', this.configGroup.name, applicantConstants.APPLICATION_GROUP_STATUS.invalid);
        if (this.applicationStatus === materialConstants.APPLY_STATUS.waittingForWrite_1) {
          this.$emit('autoSave');
        }
        this.$nextTick(() => {
          utils.scrollToElement('.invalid', 80);
        });
      }
    },
  },
  watch: {

    // 整个表单提交了，组也要提交
    formSubmitted(newVal) {
      if (typeof newVal !== 'undefined' && newVal) {
        this.saveGroup(true);
      }
    },
  },
};
</script>

<style lang="less" scoped>
div.application-group {
  padding: 40px 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /deep/ .application-subtitle + .application-field.radio-field{
    border-top: none;
  }
  .ensure-checkbox {
    margin-top: 20px;
    align-self: flex-start;
  }
  div.save-button-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0 0 0;
    .save-application-group {
      width: 300px;
      height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-group.vue